import { ValidatorFn } from '@angular/forms';

// const EMAIL_REGEX = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const emailValidator: ValidatorFn = (control) => {
  const value = control.value;
  if (typeof value !== 'string') {
    return { invalidType: 'email入力を行ってください。' };
  }
  if (!EMAIL_REGEX.test(value)) {
    return { invalidMail: 'メールアドレスを正しく入力してください。' };
  }
  return null;
};
